import { render, staticRenderFns } from "./TranslatableInputField.vue?vue&type=template&id=4372eb45&"
import script from "./TranslatableInputField.vue?vue&type=script&lang=ts&"
export * from "./TranslatableInputField.vue?vue&type=script&lang=ts&"
import style0 from "./TranslatableInputField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSelect,VTextField,VTextarea})
